// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"667":"cdef05cb","977":"96b0adc3"}[chunkId] + ".chunk.js");